/* eslint-disable react/forbid-prop-types */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ExpandCollapse, Modal, Typography } from '@telus-uds/components-web';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import UpdateOrder from './updateOrder';
import Note from '../note';
import FormSummaryGroup from '../form/formSummaryGroup';
import { ModalWidthOverride, StickyOrderModalHeader } from '../design/shared/modalOverrides';

const OrderDetails = ({
  open,
  setOpen,
  order,
  onSave = null,
  userRights,
  assignees = null,
  comments = null,
  summary,
  isSalesManager,
  isSalesSupport
}) => {
  const {
      iotOrderDetailsSection: { labelOrderDetails }
    } = useLocalizedStringsContext();
  return (
    <>
      {open && <ModalWidthOverride width="1024px" />}
      {open && <StickyOrderModalHeader />}
      <Modal
        isOpen={open}
        onClose={setOpen}
        variant={{ width: 'xl' }}
        heading={`${labelOrderDetails} - ${_.get(order, 'orderId', '')}`}
      >
        <div style={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <div className="85%">
          <UpdateOrder
            order={order}
            setOpen={setOpen}
            open={open}
            onSave={onSave}
            users={assignees}
            userRights={userRights}
            comments={comments}
            isSalesManager={isSalesManager}
            isSalesSupport={isSalesSupport}
          >
            <ExpandCollapse initialOpen={[]} topDivider={false}>
              {(expandProps) => (
                <>
                  {summary &&
                    summary.map(({ fields }) => {
                      const { note, formSummaryGroup, title } = fields;
                      if (!title) return null;
                      return (
                        <ExpandCollapse.Panel
                          key={title}
                          {...expandProps}
                          panelId={title}
                          control={<Typography variant={{ size: 'large', colour: 'brand' }}>{title}</Typography>}
                        >
                          <>
                            {note && note.content && (
                              <Note data={note} type="richText" />
                            )}
                            <FormSummaryGroup
                              data={formSummaryGroup}
                              orderData={order}
                            />
                          </>
                        </ExpandCollapse.Panel>
                      );
                    })}
                </>
              )}
            </ExpandCollapse>
          </UpdateOrder>
        </div>
      </div>
    </Modal>
    </>
  );
};

OrderDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  userRights: PropTypes.object.isRequired,
  comments: PropTypes.arrayOf(PropTypes.object),
  assignees: PropTypes.object,
  summary: PropTypes.object.isRequired,
  isSalesManager: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired
};

export default OrderDetails;
